import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import {
  Button, Form, Link, SidebarModal,
} from '@domain-group/suit-theme'

import TaskInstallationImage from '@components/TaskInstallationImage'

import useCreateOrEditOrderItemTaskModal from '../../hooks/useCreateOrEditOrderItemTaskModal'

interface OrderInstructionProps {
  hookPayload: ReturnType<typeof useCreateOrEditOrderItemTaskModal>,
}

const OrderInstructions = (props: OrderInstructionProps) => {
  const { hookPayload } = props
  const {
    campaign, disableEditing, formPayload, imageUrl, orderItemTask,
  } = hookPayload

  const {
    entityState: {
      address,
      id,
      instructions,
    },
    errors,
    handlers,
    setEntityState,
  } = formPayload

  return (
    <SidebarModal.ExpandableSectionBox
      boxProps={{ backgroundColor: 'white', marginTop: 'large' }}
      headerBoxProps={{ paddingX: '0', paddingTop: '0' }}
      contentBoxProps={{ paddingX: '0' }}
      defaultOpen
      label="Order Instructions"
    >
      {id && <TaskInstallationImage orderItemTask={orderItemTask} fullWidth />}

      {imageUrl && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faDownload} />}
          // @ts-expect-error TS2322
          marginTop="medium"
          onClick={() => window.open(imageUrl, '_blank')}
          size="medium"
        >
          Download Image
        </Button>
      )}

      <Form.Field
        errorMessage={errors.address}
        label="* Address"
        labelRight={
          !disableEditing && campaign?.id ? (
            <Link
              onClick={() => setEntityState({ address: campaign.title })}
              textProps={{ fontSize: 'xsmall' }}
            >
              Use Property Address
            </Link>
          ) : null
        }
        marginTop={id ? 'large' : 0}
      >
        <input disabled={disableEditing} name="address" value={address} type="text" {...handlers} />
      </Form.Field>

      <Form.Field direction="column" errorMessage={errors.instructions} label="Instructions" marginTop="large">
        {/*
         // @ts-expect-error TS2322 */}
        <textarea
          disabled={disableEditing}
          name="instructions"
          style={{ height: 120, resize: 'vertical' }}
          value={instructions}
          {...handlers}
        />
      </Form.Field>
    </SidebarModal.ExpandableSectionBox>
  )
}

export default OrderInstructions
